import { Button, MenuItem, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WushTextField from "../WushTextField";
import update from "../../../api/auth/orders/update";
import useOrderStore from "../../../stores/useOrderStore";
import LocationForm from "../locations/LocationForm";
import useLocationStore from "../../../stores/useLocationStore";
import index from "../../../api/auth/locations";

export default function OrderLocationForm({ order, afterUpdate }) {
  const [ location, setLocation ] = useState(order.location);
  const [ addLocation, setAddLocation ] = useState(false);

  const { locations, setLocations } = useLocationStore();
  const { updateOrder } = useOrderStore();

  const { register, handleSubmit } = useForm();

  const onSubmit = (values) => {
    update(order.id, values, (response) => {
      updateOrder(response);
      afterUpdate(response);
    }, (error) => {
      console.log(error);
    });
  };

  useEffect(() => {
    if(locations.length === 0 ) {
      index((response) => {
        setLocations(response);
      });
    }
  }, []);

  return (
    <Stack>
      <Stack>
        <Stack>
          <WushTextField formRegistration={register('location_id', { onChange: handleSubmit(onSubmit)})} defaultValue={location?.id} label="Select location" select>
            {locations.map((location) => (
              <MenuItem key={location.id} value={location.id}>
                {location.name} - {location.address_1}
              </MenuItem>
            ))}
          </WushTextField>
        </Stack>
        {addLocation ?
          <Stack mt={4}>
            <LocationForm afterCreate={(newLocation) => {
              onSubmit({ location_id: newLocation.id });
              setLocation(newLocation);
            }} />
          </Stack>
        : <Stack direction="row">
          <Button onClick={() => setAddLocation(true)}>
            New Location
          </Button>
        </Stack>}
      </Stack>
    </Stack>
  );
}